module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_enrolement_remoteEntry_mjs_abf51a2b__;